import { Link } from 'react-router-dom';
import { dossiers } from '@/mocks/dossiers';
import { formatHeat } from '@/utils/dossiers';
import DimensionTag from '@/components/feature/DimensionTag';

export default function HotBreakdown() {
  const ranked = [...dossiers].sort((a, b) => b.heat - a.heat);
  const lead = ranked[0];
  const rest = ranked.slice(1, 5);

  return (
    <section id="hot" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-8 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="font-label text-xs tracking-[0.3em] text-primary-600">热门拆解 / HOT</span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">这两天被反复翻看的几条</h2>
          </div>
          <Link
            to="/dossiers"
            className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm text-foreground-700 hover:text-primary-600"
          >
            全部档案
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
            <Link to={`/dossier/${lead.id}`} className="block">
              <div className="relative h-64 w-full overflow-hidden md:h-80">
                <img
                  src={lead.cover}
                  alt={lead.title}
                  title={`${lead.title} - 爆料看点热门拆解`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-xs text-background-50">
                  <i className="ri-fire-line" />
                  热度最高
                </span>
              </div>
            </Link>
            <div className="p-6 md:p-7">
              <DimensionTag id={lead.dimension} />
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <Link to={`/dossier/${lead.id}`} className="transition-colors hover:text-primary-600">
                  {lead.title}
                </Link>
              </h3>
              <p className="mt-4 font-body text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-foreground-500">
                <span>{lead.author}</span>
                <span>{lead.date}</span>
                <span>{lead.readTime}</span>
                <span className="text-primary-600">
                  <i className="ri-fire-line mr-1" />
                  {formatHeat(lead.heat)}
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {rest.map((item, index) => (
              <Link
                key={item.id}
                to={`/dossier/${item.id}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <span className="mt-1 font-heading text-2xl font-bold text-background-300">
                  {String(index + 2).padStart(2, '0')}
                </span>
                <div className="flex-1">
                  <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 font-label text-xs text-foreground-500">
                    <span className="text-primary-600">
                      <i className="ri-fire-line mr-1" />
                      {formatHeat(item.heat)}
                    </span>
                    <span>{item.readTime}</span>
                    <span className="hidden sm:inline">{item.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}